import { ParkingCounter } from './common/parkingTypes';
import { currentUnixTime } from './utils/utils';

export interface GlobalState {
  isLoggedIn: boolean;
  parkingStats: ParkingCounter[];
  parkingStatsUpdateTime: number;
  updateStats(newStats: ParkingCounter[]): void;
}

export const globalState: GlobalState = {
  isLoggedIn: false,
  parkingStats: [],
  parkingStatsUpdateTime: 0,
  updateStats: function (newStats: ParkingCounter[]) {
    globalState.parkingStats = newStats;
    globalState.parkingStatsUpdateTime = currentUnixTime();
  }
};